import ContractInits from "../config/contractsInit";
import { onSetUnStakeLoading } from "./layoutActions";
import Web3 from "web3";
import { onToast } from "./layoutActions";
import { getBalance, GetDashboardDataAction } from "./dashboardActions";
import axios from "axios";

const phnxToUsdApi =
  "https://min-api.cryptocompare.com/data/price?fsym=PHNX&tsyms=USD";

export const onUnStakePhnx = (
  calculateAvailablePhnx
  // , getDashboardData
) => {
  let addresss = localStorage.getItem("localaddress");
  return async (dispatch, getState) => {
    const {
      unstakeReducer: {
        availableAmount,
        earlyUnstakeAmount,
        unstakeAmount,
        stakes,
      },
      layoutReducer: { address },
      dashboardReducer: { dashboardData },
    } = await getState();

    const phnxContract = await ContractInits.initPhnxStakingContract();
    try {
      // if (address) {
      if (!Number(unstakeAmount)) {
        dispatch(
          onToast("Please enter the amount of PHNX you want to unstake.")
        );
        return;
      }
      dispatch(onSetUnStakeLoading(true));
      const _unstake = await phnxContract.methods
        .unstakeALT(
          [
            ...timestamps(stakes),
            ...burnTimestamps(
              unstakeAmount,
              availableAmount,
              earlyUnstakeAmount,
              stakes
            ),
          ],
          Web3.utils.toWei(unstakeAmount.toString())
        )
        .send({
          from: address,
        })
        .on("confirmation", function (confNumber, receipt) {
          // if (num != null) {

          if (confNumber == 1) {
            setTimeout(() => {
              dispatch(onSetUnStakeLoading(false));
              dispatch(onToast("PHNX Unstaked Successfully"));
              dispatch(getBalance(address));
              dispatch(onSetUnStakeAmount(0));
              calculateAvailablePhnx();
              dispatch(GetDashboardDataAction(address));
            }, 2000);
          }
          if (confNumber == 3) {
            dispatch(getBalance(address));
            dispatch(onSetUnStakeAmount(0));
            calculateAvailablePhnx();
            dispatch(GetDashboardDataAction(address));
          }
          if (confNumber == 5) {
            dispatch(getBalance(address));
            dispatch(onSetUnStakeAmount(0));
            calculateAvailablePhnx();
            dispatch(GetDashboardDataAction(address));
          }

          dispatch({
            type: "unstakeConfirmationNumber",
            payload: confNumber,
          });

          if (confNumber == 24) {
            dispatch({
              type: "unstakeConfirmationNumber",
              payload: 0,
            });
          }
        });

    } catch (e) {
      console.error("ERROR onUnstakePhnx => ", e);
      dispatch(onToast("Transaction rejected!"));
      dispatch(onSetUnStakeLoading(false));
    }
  };
};

export const onSetPhnxUsdValue = () => async (dispatch) => {
  const value = await axios.get(phnxToUsdApi);
  dispatch({
    type: "onSetPhnxUsdValue",
    payload: value.data.USD,
  });
};

export const onSetUnStakeAmount = (amount) => {
  return {
    type: "onUnStakeAmount",
    payload: amount,
  };
};

export const onSetWarning = (warn) => {
  return {
    type: "onWarning",
    payload: warn,
  };
};

export const onAllowedUnstake = (allowed) => {
  return {
    type: "onAllowed",
    payload: allowed,
  };
};

export const setAvailableAmount = (payload) => ({
  type: "AVAIALBLE_AMOUNT",
  payload,
});

export const setEarlyUnstakeAmount = (payload) => ({
  type: "EARLY_UNSTAKE_AMOUNT",
  payload,
});

const timestamps = (stakes) => {
  return stakes
    .filter(
      (_stake) =>
        parseFloat(_stake.id) + parseFloat(_stake.durationTimestamp) <=
        Date.now() / 1000
    )
    .map((_stake) => _stake.id);
};

const burnSingleStake = (quantity, totalDuration, remainingDuration) => {
  return (quantity * remainingDuration) / totalDuration;
};

const burnTimestamps = (amount, availablePhnx, stakedPhnx, stakes) => {
  try {
    let burn = 0;
    let timestamps = [];
    if (availablePhnx !== stakedPhnx && parseFloat(amount) > availablePhnx) {
      let remainingAmount = parseFloat(amount) - availablePhnx;
      stakes
        .filter(
          (_stake) =>
            parseFloat(_stake.id) + parseFloat(_stake.durationTimestamp) >
            Date.now() / 1000
        )
        .map((_stake) => {
          const stakeAmount = parseFloat(
            Web3.utils.fromWei(_stake.altQuantity)
          );
          if (remainingAmount >= stakeAmount) {
            remainingAmount -= stakeAmount;
            burn += burnSingleStake(
              stakeAmount,
              parseFloat(_stake.durationTimestamp) / 60,
              (parseFloat(_stake.id) +
                parseFloat(_stake.durationTimestamp) -
                Math.ceil(Date.now() / 1000)) /
                60
            );
            timestamps.push(_stake.id);
          } else {
            if (remainingAmount) {
              burn += burnSingleStake(
                remainingAmount,
                parseFloat(_stake.durationTimestamp) / 60,
                (parseFloat(_stake.id) +
                  parseFloat(_stake.durationTimestamp) -
                  Math.ceil(Date.now() / 1000)) /
                  60
              );
              timestamps.push(_stake.id);
              remainingAmount = 0;
            }
          }
        });
    }
    return timestamps;
  } catch (e) {
    console.error("Err at burnTimestamps", e);
  }
};

export const setStakes = (payload) => async (dispatch) => {
  dispatch({
    type: "STAKES",
    payload,
  });
};

export const LogoutAppAction = () => {
  return {
    type: "LOGOUT_APP",
  };
};
